/**
 * @generated SignedSource<<77f381414fd44a17a406f45adf590663>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type tagConnectionFragment$data = {
  readonly edges: ReadonlyArray<{
    readonly cursor: string;
    readonly node: {
      readonly " $fragmentSpreads": FragmentRefs<"tagFragment">;
    };
  }>;
  readonly pageInfo: {
    readonly " $fragmentSpreads": FragmentRefs<"pageInfoFragment">;
  };
  readonly " $fragmentType": "tagConnectionFragment";
};
export type tagConnectionFragment$key = {
  readonly " $data"?: tagConnectionFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"tagConnectionFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "tagConnectionFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "TagEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "cursor",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Tag",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "tagFragment"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "PageInfo",
      "kind": "LinkedField",
      "name": "pageInfo",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "pageInfoFragment"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "TagConnection",
  "abstractKey": null
};

(node as any).hash = "38b4fc998400fa7a60762ec83a89ba81";

export default node;
